"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoveRandomDebuffActionHandler = exports.RemoveRandomDebuffActionArgs = void 0;
const Registries_1 = require("../../state/Registries");
const ActionType_1 = require("../ActionType");
const Random_1 = require("../../../utils/Random");
class RemoveRandomDebuffActionArgs {
    constructor() {
        this.__type = ActionType_1.ActionType.RemoveRandomDebuff;
        this.__typeName = "RemoveRandomDebuff";
    }
}
exports.RemoveRandomDebuffActionArgs = RemoveRandomDebuffActionArgs;
let RemoveRandomDebuffActionHandler = class RemoveRandomDebuffActionHandler {
    activate(sequence, container, action) {
        if (container.isDeceased(action.actorId)) {
            return;
        }
        const debuffs = container.getHarmfulEffects(action.actorId);
        if (debuffs.length === 0) {
            return;
        }
        const toRemove = (0, Random_1.randomElement)(debuffs);
        container.cancelEffect(sequence, toRemove.id);
    }
};
RemoveRandomDebuffActionHandler = __decorate([
    Registries_1.Actions.register(ActionType_1.ActionType.RemoveRandomDebuff)
], RemoveRandomDebuffActionHandler);
exports.RemoveRandomDebuffActionHandler = RemoveRandomDebuffActionHandler;
